import React from 'react'
import styled from '@emotion/styled'
import ConfirmationModal, { ModalDescription } from '../ConfirmationModal'

interface DisconnectLocationModalProps {
  selectedRows: string[]
  isOpen: boolean
  onOk: () => void
  onCancel: () => void
  confirmLoading?: boolean
}

const DisconnectLocationModal = ({
  selectedRows,
  onCancel,
  onOk,
  isOpen,
  confirmLoading
}: DisconnectLocationModalProps) => {
  return (
    <ConfirmationModal
      title='Remove location connection'
      confirmLabel='Remove connection'
      isOpen={isOpen}
      onOk={onOk}
      onCancel={onCancel}
      confirmLoading={confirmLoading}
    >
      <ModalDescription>
        This will remove the connection between the following store(s) and their
        Lightspeed location:
      </ModalDescription>

      <ModalDescription>
        <List>
          {selectedRows.map((row) => (
            <li key={row}>{row}</li>
          ))}
        </List>
      </ModalDescription>

      <ModalDescription>
        These stores will lose access to Lightspeed menus and you'll need to
        reconnect them to assign menus again
      </ModalDescription>
    </ConfirmationModal>
  )
}

const List = styled.ul`
  padding-left: 22px;
`

export default DisconnectLocationModal
